import type { Roof } from "building-types/roofs/roofSystemTypes";

export function nonEmptyGableSubRoof(subRoof: Roof): boolean {
  if (!subRoof) {
    return false;
  }
  if (subRoof.disabled) {
    return false;
  }
  const { blocks } = subRoof;
  return !(blocks instanceof Array) || blocks.length !== 0;
}
